<div class="modal-header">
  <h4 class="modal-title pull-left">Import Stops</h4>
  <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    [disabled]="loading"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-import-stops
    [hostEvent]="hostEvent$ | async"
    (eventChange)="handleEvent($event)"
    [route]="route"
  ></app-import-stops>
</div>
<div class="modal-footer">
  <button
    *ngIf="showBackButton"
    class="btn btn-outline-dark ml-0"
    [disabled]="loading"
    (click)="goBack()"
  >
    Back
  </button>
  <button
    class="btn btn-outline-dark ml-auto"
    [disabled]="loading"
    (click)="close()"
  >
    Cancel
  </button>
  <button
    class="btn btn-primary ml-2"
    *ngIf="!enableContinueButton"
    [disabled]="loading || disableInputButton"
    (click)="import()"
  >
    Import
  </button>
  <button
    class="btn btn-primary ml-2"
    *ngIf="enableContinueButton"
    (click)="continue()"
  >
    Continue
  </button>
</div>
